import CLEDetail from './CLEDetail';

export default CLEDetail;
